import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const GRID_GAUNTLET_MODE: ModeDescription = {
  mode: GameMode.GRID_GAUNTLET,
  title: 'Grid Gauntlet',
  description: 'Chain answers across five rolling questions to build momentum.',
  icon: '🧩',
};
